import YtDialogForm from './dialog-form'

export default {
  install: (Vue) => {
    Vue.component('yt-dialog-form', YtDialogForm)
  }
}